import { LocationDescriptorObject } from 'history';
import { remove } from './object-prop';

/**
 * parse/modify location history object search
 */
export class LocationUtil {
  private param: LocationDescriptorObject;
  private search: URLSearchParams;
  private hash: string;
  private path: string;

  constructor(param: LocationDescriptorObject) {
    this.param = param;
    this.search = new URLSearchParams(param.search);
  }

  setPathName(path: string) {
    this.param.pathname = path;
    return this;
  }

  getSearchByKey(key: string): string {
    return this.search.get(key);
  }

  setSearchByKeyVal(key: string, value: string): this {
    this.search.set(key, value);
    return this;
  }

  setSearchByString(queries: string): this {
    for (const [key, val] of Object.entries(queries)) {
      this.setSearchByKeyVal(key, val);
    }

    return this;
  }

  setSearchByObj(search: object): this {
    Object.entries(search).forEach(([key, val]) => {
      this.setSearchByKeyVal(key, val);
    });
    return this;
  }

  toggleSearchValue(key: string, value: string): this {
    const all = this.search.getAll(key);
    const indexVal = all.indexOf(value);
    // add if not in parameter
    if (indexVal === -1) {
      this.search.append(key, value);
    } else {
      const clean = remove(all, `${indexVal}`);
      this.search.delete(key);
      // update filters
      clean.forEach(val => this.search.append(key, val));
    }

    return this;
  }

  removeSearch(names: string[]): this {
    names.forEach(name => {
      this.search.delete(name);
    });

    return this;
  }

  toString(): string {
    if (!this.param.pathname) {
      return '';
    }

    let url: string = this.param.pathname;
    const search = this.search.toString();
    if (search.length > 0) {
      url += '?' + this.search.toString();
    }

    const hash = this.hash;
    if (hash) {
      url += `#${hash}`;
    }
    return url;
  }

  toDescriptor(): LocationDescriptorObject {
    const descriptor = this.param;
    descriptor.search = '?' + this.search.toString();
    return descriptor;
  }

  setHash(hash: string) {
    this.hash = hash;
    return this;
  }
}

export const locationParser = (param: LocationDescriptorObject) => {
  return new LocationUtil(param);
};
